import React from "react";
import SInternalLinkBio from "./SInternalLinkBio/SInternalLinkBio";
import SExternalLinkBio from "./SExternalLinkBio/SExternalLinkBio";

const BUTTON_COMPONENTS = {
  internal_link_button: SInternalLinkBio,
  external_link_button: SExternalLinkBio,
};

const SecundaryBtnLinkBio = ({ options }) => {
  //Des
  const { objinfo = {} } = options;
  const { version } = objinfo || {};

  const ButtonComponent = BUTTON_COMPONENTS[version];

  if (!ButtonComponent) return null;

  return <ButtonComponent options={options} />;
};

export default SecundaryBtnLinkBio;
